// Con CSS global las clases se usan tal cual: styles.hero === "hero".
export const styles: Record<string, string> = new Proxy<Record<string, string>>(
  {},
  { get: (_target, key) => (typeof key === "string" ? key : undefined) },
);
